








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ADD_CONSERVATEE_PUBLIC_NUMBER } from '../../../store/actions';
import { AddPhoneNumber, ConservatorshipDetails } from '../../../types';
import { ApiResponse } from '@/components/types';

const Conservatorship = namespace('conservatorship');

@Component({})
export default class PublicNumberAddDialog extends Vue {
  @Prop({ type: Object, required: true }) conservatorship!: ConservatorshipDetails;
  @Conservatorship.Action(ADD_CONSERVATEE_PUBLIC_NUMBER) addNumber!: (params: AddPhoneNumber) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  value: AddPhoneNumber = {
    conservatee_id: this.conservatorship.id,
    phone_number: this.conservatorship.conservatee.publicNumber || ''
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) {
      this.value = {
        conservatee_id: this.conservatorship.id,
        phone_number: this.conservatorship.conservatee.publicNumber || ''
      };

      return;
    }

    setTimeout(() => {
      // @ts-ignore
      this.$refs.form.reset();
      this.error = null;
    }, 200);
  }

  async save() {
    this.error = null;

    return await this.addNumber(this.value);
  }

  async remove() {
    this.error = null;

    return this.addNumber({
      conservatee_id: this.conservatorship.id,
      phone_number: ''
    });
  }
}
